export default __webpack_public_path__ + "static/media/founder__img.55858070.jpg";